import {Directive, TemplateRef} from "@angular/core";

/**
 * Структурная директива для переопределения шаблона шапки аврийной страницы.
 * @publicApi
 */
@Directive({selector: '[dxErrorPageHeader]'})
export class DxErrorPageHeaderDirective {
  constructor(public template: TemplateRef<any>) { }
}
